<template>
  <div class="cmp-header" ref="cmp_header">
    <div class="header-left">
      <img alt="logo" class="logo" src="@image/title.png" />
    </div>
    <el-menu
      :router="true"
      active-text-color
      class="el-menu-top"
      mode="horizontal"
    >
      <el-menu-item :index="ylStatus ? '/home_yl' : '/'">首页</el-menu-item>
      <!-- <el-menu-item index="/about">关于我们</el-menu-item>
      <el-menu-item index="/culture">企业文化</el-menu-item>
      <el-menu-item index="/news">新闻聚焦</el-menu-item>
      <el-menu-item index="/business">业务专区</el-menu-item>
      <el-menu-item index="/recruit">人才招聘</el-menu-item>
      <el-menu-item index="/connection">联系我们</el-menu-item>-->
      <el-submenu index="/about" popper-class="popper">
        <template slot="title">关于我们</template>
        <router-link
          :to="{
            name: ylStatus ? 'about_yl' : 'about',
            query: { routerPath: 'qyjj' }
          }"
        >
          <el-menu-item>企业简介</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'about_yl' : 'about',
            query: { routerPath: 'ldtd' }
          }"
        >
          <el-menu-item>领导团队</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'about_yl' : 'about',
            query: { routerPath: 'zzjg' }
          }"
        >
          <el-menu-item>组织架构</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'about_yl' : 'about',
            query: { routerPath: 'fzlc' }
          }"
        >
          <el-menu-item>发展历程</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'about_yl' : 'about',
            query: { routerPath: 'qyry' }
          }"
        >
          <el-menu-item>企业荣誉</el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="/culture" popper-class="popper">
        <template slot="title">企业文化</template>
        <router-link
          :to="{
            name: ylStatus ? 'culture_yl' : 'culture',
            query: { routerPath: 'pnwh' }
          }"
        >
          <el-menu-item>品农文化</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'culture_yl' : 'culture',
            query: { routerPath: 'pnsh' }
          }"
        >
          <el-menu-item>品农生活</el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="/news" popper-class="popper">
        <template slot="title">新闻聚焦</template>
        <router-link
          :to="{
            name: ylStatus ? 'news_yl' : 'news',
            query: { routerPath: 'qyxw' }
          }"
        >
          <el-menu-item>企业新闻</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'news_yl' : 'news',
            query: { routerPath: 'hydt' }
          }"
        >
          <el-menu-item>行业动态</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'news_yl' : 'news',
            query: { routerPath: 'hzxw' }
          }"
        >
          <el-menu-item>伙伴频道</el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="/business" popper-class="popper">
        <template slot="title">业务专区</template>
        <router-link
          :to="{
            name: ylStatus ? 'business_yl' : 'business',
            query: { routerPath: 'qyys' }
          }"
        >
          <el-menu-item>企业优势</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'business_yl' : 'business',
            query: { routerPath: 'city' }
          }"
        >
          <el-menu-item>业务范围</el-menu-item>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'business_yl' : 'business',
            query: { routerPath: 'hzhb' }
          }"
        >
          <el-menu-item>合作伙伴</el-menu-item>
        </router-link>
      </el-submenu>
      <el-menu-item :index="ylStatus ? '/recruit_yl' : '/recruit'"
        >人才招聘</el-menu-item
      >
      <el-menu-item :index="ylStatus ? '/connection_yl' : '/connection'"
        >联系我们</el-menu-item
      >
    </el-menu>

    <div class="tel">
      <!-- <strong>品农学院</strong> -->
      <div @click="jumpOA" class="oa">
        <i class="el-icon-reading study"></i>
        <!-- <img alt="企业邮箱" src="@image/emailh.png" /> -->
        <strong>品农学院</strong>
      </div>
      <div @click="jumpEmail" class="email">
        <img alt="企业邮箱" src="@image/emailh.png" />
        <strong>企业邮箱</strong>
      </div>
      <img alt="400-800-7969" src="@image/tel.png" />
      <strong>400-800-7969</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cmpHeader',
  data() {
    return {
      ylStatus: this.$store.getters.urlStatus
    }
  },
  // 监听头部滚动位置
  mounted() {
    window.addEventListener('scroll', this.handleScrollNav)
  },
  methods: {
    handleScrollNav() {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      const height = sessionStorage.getItem('bannerHeight')
      if (top >= height - 200) {
        this.$refs.cmp_header.style.backgroundColor = '#013165'
      } else {
        this.$refs.cmp_header.style.backgroundColor = 'rgba(2, 17, 33, 0.2)'
      }
    },
    jumpEmail() {
      window.open('http://mail.pinnongjt.com/')
    },
    jumpOA() {
      window.open('http://oa.pinnongjt.com/platform/index/login.html')
    }
  },
  //离开页面移除方法
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollNav)
  }
}
</script>

<style lang="scss" scoped>
.cmp-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 111;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  min-width: 1440px;
  height: 60px;
  // border-bottom: 2px solid rgba(12, 25, 106, 0.15);
  background: rgba(2, 17, 33, 0.2);
  strong {
    color: rgba(255, 255, 255, 1);
    font-size: 30px;
    font-weight: 400;
  }
  .header-left {
    // padding-left: 30px;
    margin-right: 0px;
    .logo {
      width: 181px;
      height: 34px;
      // margin-right: 30px;
    }
  }

  .el-menu-top {
    // flex: 1;
  }
  .tel {
    padding-right: 80px;
    // width: 200px;
    // height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // color: #fff;
    strong {
      font-size: 20px;
    }
    img {
      vertical-align: middle;
      margin-right: 10px;
    }
  }
  .oa {
    margin: 0 20px 0 0;
    line-height: 40px;
    cursor: pointer;
    .study {
      color: #fff;
      vertical-align: middle;
      font-size: 25px;
      margin-right: 8px;
    }
    strong {
      font-size: 17px;
      line-height: 2px;
    }
  }
  .oa:hover {
    strong {
      color: #0d7ef8;
    }
  }
  .email {
    display: flex;
    margin-right: 35px;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
    img {
      width: 21px;
      height: 18px;
      vertical-align: middle;
      margin-right: 10px;
      position: relative;
      top: 1px;
    }
    strong {
      font-size: 17px;
      line-height: 2px;
    }
  }
  .email:hover {
    strong {
      color: #0d7ef8;
    }
  }
  /deep/.el-menu-top {
    .el-submenu__title {
      color: #fff;
      font-size: 18px;
    }
    .el-submenu__title:hover {
      background: none;
      color: #0d7ef8;
    }
  }

  .el-menu-item {
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
  }

  // .el-menu--horizontal > .el-menu-item.is-active {
  //   border-bottom: none !important;
  //   color: rgb(119, 38, 38) !important;
  //   font-size: 16px;
  // }
  .el-submenu__title:hover {
    color: #0d7ef8 !important;
  }
  .el-menu--horizontal > .el-menu-item {
    color: #fff;
    border-bottom: none;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #fff;
  }
  .el-menu-item:hover {
    color: #0d7ef8 !important;
  }
  .el-menu-item.is-active {
    background: none;
  }
  .el-submenu__title.is-active {
    background: #0d7ef8 !important;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1) !important;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    // color: #0d7ef8 !important;
    font-size: 18px;
  }
}
</style>
